import { translate } from '@fiverr-private/i18n-react';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { BQ_CONSTS } from './constants';

const getMdeiaAction = ({ isPlaying }) => {
    const {
        MEDIA_ACTIONS: { START, STOP },
    } = BQ_CONSTS;

    let mediaAction;
    if (typeof isPlaying === 'boolean') {
        mediaAction = isPlaying ? START : STOP;
    }

    return mediaAction;
};

export const enrichPageView = () => {
    const {
        GROUPS: { PAGE_VIEW: PAGE_VIEW_GROUP },
        ACTION_TYPES: { PAGE_VIEW: PAGE_VIEW_ACTION },
    } = BQ_CONSTS;

    return {
        group: PAGE_VIEW_GROUP,
        action: {
            type: PAGE_VIEW_ACTION,
        },
    };
};

export const enrichRedirectButtonClicked = ({ redirectUrl, info, resourceId, resourceType, fileType, position }) => {
    const {
        GROUPS: { ACTIONS },
        ACTION_TYPES: { CLICK },
    } = BQ_CONSTS;
    return {
        group: ACTIONS,
        action: {
            type: CLICK,
        },
        page: {
            element: {
                metadata: redirectUrl,
                name: info,
                text: translate('assets_sharing.overview_card.redirect_button.label', {
                    locale: DEFAULT_FIVERR_LOCALE,
                }),
            },
        },
        assets_sharing: {
            asset: {
                resource_id: resourceId,
                type: resourceType,
                file_type: fileType,
                position,
            },
        },
    };
};

export const enrichSellerOverviewHovered = () => {
    const {
        GROUPS: { HOVER: HOVER_GROUP },
        ACTION_TYPES: { HOVER: HOVER_ACTION },
    } = BQ_CONSTS;
    return {
        group: HOVER_GROUP,
        action: {
            type: HOVER_ACTION,
        },
    };
};

export const enrichAssetClicked = ({ resourceUrl, resourceId, resourceType, fileType, position, isPlaying }) => {
    const {
        GROUPS: { ACTIONS },
        ACTION_TYPES: { CLICK },
    } = BQ_CONSTS;

    return {
        group: ACTIONS,
        action: {
            type: CLICK,
        },
        page: {
            element: {
                metadata: resourceUrl,
                state: getMdeiaAction({ isPlaying }),
            },
        },
        assets_sharing: {
            asset: {
                resource_id: resourceId,
                type: resourceType,
                file_type: fileType,
                position,
            },
        },
    };
};

export const enrichAssetShown = ({ resourceUrl, resourceId, resourceType, fileType, position }) => {
    const {
        GROUPS: { IMPRESSION: IMPRESSION_GROUP },
        ACTION_TYPES: { IMPRESSION: IMPRESSION_ACTION },
    } = BQ_CONSTS;

    return {
        group: IMPRESSION_GROUP,
        action: {
            type: IMPRESSION_ACTION,
        },
        page: {
            element: {
                metadata: resourceUrl,
            },
        },
        assets_sharing: {
            asset: {
                resource_id: resourceId,
                type: resourceType,
                file_type: fileType,
                position,
            },
        },
    };
};

export const enrichFooterShown = () => {
    const {
        GROUPS: { IMPRESSION: IMPRESSION_GROUP },
        ACTION_TYPES: { IMPRESSION: IMPRESSION_ACTION },
    } = BQ_CONSTS;

    return {
        group: IMPRESSION_GROUP,
        action: {
            type: IMPRESSION_ACTION,
        },
    };
};

export const enrichFooterPlayed = ({ isPlaying }) => {
    const {
        GROUPS: { ACTIONS },
        ACTION_TYPES: { CLICK },
    } = BQ_CONSTS;

    return {
        group: ACTIONS,
        action: {
            type: CLICK,
        },
        page: {
            element: {
                state: getMdeiaAction({ isPlaying }),
            },
        },
    };
};

export const enrichSellerClicked = () => {
    const {
        GROUPS: { ACTIONS },
        ACTION_TYPES: { CLICK },
    } = BQ_CONSTS;

    return {
        group: ACTIONS,
        action: {
            type: CLICK,
        },
    };
};
